// extracted by mini-css-extract-plugin
module.exports = {"colors":"'~styles/colors.module.css'","PURPLE":"#830051","spinner":"styles_spinner__wRTlm"};